import React from 'react';
import { usePermissions } from '@/contexts/PermissionsContext';
import { Button } from '@/components/ui/button';

/**
 * Bouton qui s'affiche uniquement si l'utilisateur a la permission requise
 * 
 * Usage:
 * <ProtectedButton resource="chauffeurs" action="create" onClick={handleCreate}>
 *   Ajouter un chauffeur
 * </ProtectedButton>
 */
export const ProtectedButton = ({ 
  resource, 
  action, 
  children, 
  fallback = null,
  ...buttonProps 
}) => {
  const { hasPermission } = usePermissions();
  
  if (!hasPermission(resource, action)) {
    return fallback;
  }
  
  return <Button {...buttonProps}>{children}</Button>;
};
